// Notify Me (back in stock) toggle.
//
// The server renders the <notify-me> form visible or hidden based on the
// currently-selected variant's availability. On a client-side variant change,
// Dawn does not re-render the buy-buttons markup — it only toggles the submit
// button and publishes `variantChange`. We subscribe to that same event and
// mirror the freshly-fetched submit button's disabled state so the notify form
// appears/disappears in step with sold-out status, without a page reload.

if (!customElements.get('notify-me')) {
  customElements.define(
    'notify-me',
    class NotifyMe extends HTMLElement {
      connectedCallback() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const data = event?.data;
          if (!data || !data.html) return;

          // Only react to changes for this product section.
          if (this.dataset.sectionId && String(data.sectionId) !== this.dataset.sectionId) return;

          const submitButton = data.html.getElementById(`ProductSubmitButton-${data.sectionId}`);
          // A disabled submit button in the fetched markup means the newly
          // selected variant is sold out / unavailable.
          const soldOut = submitButton ? submitButton.hasAttribute('disabled') : false;
          this.toggle(soldOut);
        });
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }

      toggle(soldOut) {
        if (soldOut) {
          this.removeAttribute('hidden');
        } else {
          this.setAttribute('hidden', '');
        }
      }
    }
  );
}
